export type LabeledSelectValue<T> = {
  value: T;
  label: string;
};

export const toLabeledSelectValue = <T>(
  value: T,
  label: string,
): LabeledSelectValue<T> => ({
  value,
  label,
});

export const getLabeledSelectValue = <T>(
  option: LabeledSelectValue<T>,
): T => option.value;
